import Rombel from "../../../../../components/categories/siakad/lms/data_rombel/Home";
export default function Home() {
  
  return (
    <Rombel />
  );
}
